module.exports = new __parcel__URL__("pvp_surrender_button.737c8566.png").toString();